import {
  Box,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useDebugValue, useEffect, useMemo, useRef, useState } from 'react';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import Loader3D from '../../../../components/Loader/Loader3D';
import NoDataFound from '../../../../components/NodataIndication/NoDataFound';
import { useDispatch } from 'react-redux';
import { getChaserCrewPerfomance } from '../../../../redux/features/poinTrackerSlice';
import { useSelector } from 'react-redux';
import { getProjects } from '../../../../redux/features/refundSlice';
import { getCourseUnderProject } from '../../../../redux/features/courseSlice';



const ChaserCrewPerfomance = ({
  selectedProject,
  selectedCourse,
  setSelectedProject,
  setSelectedCourse,
  fromDate,
  toDate,
  selectedTeam,
}) => {
  const [limit, setLimit] = useState(10);
  const chaserCrewPerfomance = useSelector((state) => state.pointTracker.chaserCrewPerfomance);
  const { projectslist: projects = [] } = useSelector((state) => state.refund);
  const { courseUnderProject: courses = [] } = useSelector((state) => state.course);
  const { responseData, loading } = chaserCrewPerfomance;
  const dispatch = useDispatch();
  const dispatchParams = useMemo(() => {
    return {
      fromDate,
      toDate,
      wingId: selectedTeam.id === -1 ? null : selectedTeam.id,
      courseId: selectedCourse.id === -1 ? null : selectedCourse.id,
      projectId: selectedProject.id === -1 ? null : selectedProject.id,
    };
  }, [fromDate, toDate, selectedTeam.id, selectedCourse.id, selectedProject.id]);

  const previousDispatchParams = useRef(dispatchParams);
  const isApiNeeded = JSON.stringify(previousDispatchParams.current) !== JSON.stringify(dispatchParams);
  const lastSelectedProjectId = useRef(selectedProject.id);
  useEffect(() => {
    if (projects.length <= 1) {
      dispatch(getProjects());
    }
  }, [projects.length]);

  useEffect(() => {
    if (lastSelectedProjectId.current !== selectedProject.id) {
      dispatch(getCourseUnderProject(selectedProject.id));
      lastSelectedProjectId.current = selectedProject.id;
    }
  }, [selectedProject.id]);

  useEffect(() => {
    if (Object.entries(chaserCrewPerfomance?.responseData || {}).length === 0 || isApiNeeded) {
      dispatch(getChaserCrewPerfomance(dispatchParams));
      previousDispatchParams.current = dispatchParams;
    }
  }, [dispatch, dispatchParams, chaserCrewPerfomance?.responseData, isApiNeeded]);

  const data = responseData?.data?.slice(0, limit) || [];
  const noDataFound = Boolean(data?.length === 0);

  const headersAndSubHeaders = [
    {
      header: { key: 'overall', label: 'OVERALL PERFORMANCE' },
      subHeaders: [
        { key: 'sales', label: 'ADM' },
        { key: 'revenue', label: 'SALES' },
        { key: 'adm', label: 'NET REV' },
        { key: 'arpu', label: 'ARPU' },
        { key: 'ads', label: 'ADS' },
      ],
    },
    {
      header: {
        key: 'projectPerformance',
        label: selectedProject.value
          ? selectedProject.id !== -1
            ? selectedProject.value
            : 'Project Performance'
          : 'Project Performance',
      },
      subHeaders: [
        { key: 'sales', label: 'ADM' },
        { key: 'revenue', label: 'SALES' },
        { key: 'adm', label: 'NET REV' },
      ],
    },
    {
      header: {
        key: 'coursePerformance',
        label: selectedCourse.value
          ? selectedCourse.id !== -1
            ? selectedCourse.value
            : 'Course Performance'
          : 'Course Performance',
      },
      subHeaders: [
        { key: 'sales', label: 'ADM' },
        { key: 'revenue', label: 'SALES' },
        { key: 'adm', label: 'NET REV' },
      ],
    },
  ];

  return (
    <Box mt={2}>
      <Box display={'flex'} gap={2} width={{ xs: '100%', md: '50%' }}>
        <GlobalSelectFieldWithoutFormikNew
          sx={{
            '& .MuiInputBase-root': {
              height: 36,
              fontSize: '0.75rem',
            },
          }}
          data={projects}
          selectedDetails={selectedProject}
          setChange={setSelectedProject}
          keys={{ itemId: 'id', itemValue: 'name' }}
          label="Project"
          fullWidth
        />
        <GlobalSelectFieldWithoutFormikNew
          sx={{
            '& .MuiInputBase-root': {
              height: 36,
              fontSize: '0.75rem',
            },
          }}
          data={[{ course_available_id: -1, course_name: 'All' }, ...courses]}
          selectedDetails={selectedCourse}
          setChange={setSelectedCourse}
          keys={{ itemId: 'course_available_id', itemValue: 'course_name' }}
          label="Course"
          fullWidth
        />
      </Box>

      <Box mt={2}>
        {/* FILTER SECTION */}

        {/* TITLE */}
        <Typography fontWeight={600} mb={2}>
          {'Team - ' + selectedTeam.value + ' Performance'}
        </Typography>

        {/* TABLE */}
        <Paper elevation={5}>
          <Box sx={{ overflowX: 'auto', backgroundColor: 'white', borderRadius: { xs: '10px', md: '10px' } }}>
            {loading ? (
              <Loader3D />
            ) : noDataFound ? (
              <NoDataFound />
            ) : (
              <Table
                size="small"
                sx={{
                  borderCollapse: 'collapse',
                  border: '1px solid #a5a5a5',

                  '& th, & td': {
                    border: '1px solid #a5a5a5',
                    padding: '6px 10px',
                  },
                }}
              >
                <TableHead>
                  {/* MAIN HEADER */}
                  <TableRow>
                    <TableCell
                      rowSpan={2}
                      sx={{
                        backgroundColor: '#334155',
                        color: '#fff',
                        fontWeight: 700,
                        minWidth: 250,
                        textAlign: 'center',
                      }}
                    >
                      SALES EXECUTIVE
                    </TableCell>

                    {headersAndSubHeaders.map(({ header, subHeaders }) => (
                      <TableCell
                        key={header.key}
                        colSpan={subHeaders.length}
                        align="center"
                        sx={{
                          backgroundColor: '#334155',
                          color: '#fff',
                          fontWeight: 700,
                          textAlign: 'center',
                        }}
                      >
                        {header.label}
                      </TableCell>
                    ))}
                  </TableRow>

                  {/* SUB HEADER */}
                  <TableRow>
                    {headersAndSubHeaders.map(({ header, subHeaders }) =>
                      subHeaders.map((sub) => (
                        <TableCell
                          key={`${header.key}-${sub.key}`}
                          align="center"
                          sx={{
                            backgroundColor: '#e2e8f0',
                            color: '#0f172a',
                            fontWeight: 600,
                          }}
                        >
                          {sub.label}
                        </TableCell>
                      )),
                    )}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {data.map((row) => (
                    <TableRow
                      key={row.userId}
                      sx={{
                        '&:nth-of-type(even)': {
                          backgroundColor: '#f8fafc',
                        },
                        '&:hover': {
                          backgroundColor: '#eef2ff',
                        },
                      }}
                    >
                      <TableCell sx={{ fontWeight: 600 }}>{row.userName}</TableCell>

                      {headersAndSubHeaders.map(({ header, subHeaders }) =>
                        subHeaders.map((sub) => (
                          <TableCell key={`${row.userId}-${header.key}-${sub.key}`} align="center">
                            {row?.[header.key]?.[sub.key] ?? 0}
                          </TableCell>
                        )),
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </Box>
          <Box p={1}>
            {/* DROP DOWN SECTION */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Select
                size="small"
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                sx={{
                  ml: 1,
                  height: 32,
                  fontSize: 12,
                  '& .MuiSelect-select': { py: 0.5, px: 1 },
                }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
                <MenuItem value={200}>200</MenuItem>
                <MenuItem value={500}>500</MenuItem>
              </Select>

              <Typography variant="caption" fontSize={12}>
                {`${limit} / ${responseData?.data?.length}`}
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default ChaserCrewPerfomance;
